<template>
    <div>
        <v-container grid-list-xs>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-actions>
                            <BackButton />
                        </v-card-actions>
                        <v-card-text>
                            <v-subheader class="text-subtitle-1 font-weight-bold">CREDIT REPORT AUTHORIZATION</v-subheader>
                            <b>Consumer Report Authorization.</b>  You authorize Company and Company's Participating Creditors to obtain consumer
                            reports and related information about you from one or more consumer reporting agencies and other third parties.
                            You also authorize Company’s Participating Creditors to verify information in each of your prequalification
                            requests, or application for credit, and you agree that Company’s Participating Creditors may
                            contact third parties to verify any such information. You direct Company’s Participating
                            Creditors to use your consumer reports to authenticate your identity, to make/facilitate prequalification
                            decisions and for other related purposes.  You expressly authorize Company’s Participating Creditors
                            to obtain consumer reports about you, as well as your income information, from consumer reporting agencies
                            when you apply through the Platform and anytime thereafter until credit is extended.
                            <br>
                            <br>
                            You expressly authorize Company’s Participating Creditors to use and share among themselves the
                            information they obtain from such reports along with your prequalification request or application information
                            to, among other things, market credit products to you, determine your eligibility for other products that Company’s
                            Participating Creditors may offer or that you may apply for, make decisions related to the servicing and
                            collection of your account, measure how any credit product you obtained impacts your credit, perform
                            other statistical analysis, share information with you about your credit profile, and for any other
                            related purposes.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .v-card__text {
        color: #000000 !important;

        .theme--light.v-subheader {
            color: #000000;
        }
    }


</style>
